module.exports = {"520102016":"新华路街道","520102017":"西湖路街道","520102018":"水口寺街道","520102019":"中华南路街道","520102020":"河滨街道","520102021":"遵义路街道","520102022":"兴关路街道","520102023":"沙冲路街道","520102024":"望城街道","520102025":"太慈桥街道","520102026":"湘雅街道","520102027":"油榨街道","520102028":"中曹司街道","520102029":"二戈街道","520102030":"龙洞堡街道","520102031":"花果园街道","520102032":"小车河街道","520102033":"五里冲街道","520102200":"后巢乡","520102201":"云关乡","520102202":"小碧布依族苗族乡","520102203":"永乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520102.json
// module id = 2579
// module chunks = 0